import { parseUtcTimestamp } from "../../lib/parse-utc";

export function formatDateTime(value?: string): string {
  if (!value) return "-";
  const date = parseUtcTimestamp(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
